import StitchHint from "@/components/common/stitch-hint.vue";
import SettingsRow from "@/components/common/settings-row.vue";
import Action from "@/components/common/action";
import BulkResultDialog from "@/components/common/bulk-result-dialog.vue";
import Actions from "@/components/common/actions";
import AddressForm from "@/components/common/address";
import AmountInput from "@/components/common/amount-input.vue";
import Back from "@/components/common/back.vue";
import BarChart from "@/components/charts/bar.vue";
import Block from "@/components/common/block.vue";
import Button from "@/components/common/button.vue";
import Contentful from "@/components/common/contentful";
import CustomerName from "@/components/common/customer-name";
import CountrySelect from "@/components/common/country-select";
import DateTime from "@/components/common/datetime.vue";
import DoughnutChart from "@/components/charts/doughnut.vue";
import DropZone from "@/components/common/dropzone.vue";
import Emails from "@/components/common/emails";
import Error from "@/components/common/error";
import ErrorPlaceholder from "@/components/common/error-placeholder";
import Errors from "@/components/common/errors";
import Field from "@/components/common/field.vue";
import File from "@/components/common/file.vue";
import FormatSelect from "@/components/common/format-select.vue";
import Filters from "@/components/filters/filters.vue";
import Graph from "@/components/common/graph";
import InfiniteAutocomplete from "@/components/common/infinite-autocomplete";
import Info from "@/components/common/info";
import InfoCard from "@/components/common/infocard";
import LineChart from "@/components/charts/line.vue";
import List from "@/components/list/list.vue";
import Loading from "@/components/common/loading";
import Lookup from "@/components/common/lookup";
import MasterSvg from "@/components/common/master-svg.vue";
import MetadataSearch from "@/components/common/metadata-search";
import Modal from "@/components/modal/modal";
import ModalContent from "@/components/modal/modalcontent";
import SwalDialog from "@/components/common/swal-dialog.vue";
import Placeholder from "@/components/common/placeholder";
import Price from "@/components/common/price";
import QuantityInput from "@/components/common/quantity-input.vue";
import ProductName from "@/components/common/product-name";
import SearchBillingAccount from "@/components/common/search-billingaccount";
import SearchCatalog from "@/components/common/search-catalog";
import SearchCustomer from "@/components/common/search-customer";
import SearchCustomerInvoice from "@/components/common/search-customerinvoice";
import SearchEstablishment from "@/components/common/search-establishment";
import SearchObject from "@/components/common/search-object";
import SearchProduct from "@/components/common/search-product";
import SearchProvider from "@/components/common/search-provider";
import SearchStock from "@/components/common/search-stock";
import SearchShipment from "@/components/common/search-shipment";
import SearchReceipt from "@/components/common/search-receipt";
import SearchOrder from "@/components/common/search-order";
import SearchOrganization from "@/components/common/search-organization";
import SearchUser from "@/components/common/search-user";
import ProviderName from "@/components/common/provider-name";
import ReadonlyAccount from "@/components/common/readonlyaccount";
import RessourceError from "@/components/common/ressource-error";
import RessourceNotFound from "@/components/common/ressource-not-found";
import ScopedRouteLink from "@/components/common/scoped-route-link.vue";
import Select from "@/components/common/select.vue";
import SelectFile from "@/components/common/selectfile.vue";
import Stat from "@/components/common/stat";
import Strike from "@/components/common/strike";
import Table from "@/components/table/table.vue";
import Tabs from "@/components/common/tabs";
import TextField from "@/components/fields/text.vue";
import Title from "@/components/common/title.vue";
import Warning from "@/components/common/warning";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";

export default {
        install(Vue) {
                Vue.component("Action", Action);
                Vue.component("Actions", Actions);
                Vue.component("AmountInput", AmountInput);
                Vue.component("BulkResultDialog", BulkResultDialog);
                Vue.component("AddressForm", AddressForm);
                Vue.component("SettingsRow", SettingsRow);
                Vue.component("Back", Back);
                Vue.component("BarChart", BarChart);
                Vue.component("Block", Block);
                Vue.component("Button", Button);
                Vue.component("Contentful", Contentful);
                Vue.component("CountrySelect", CountrySelect);
                Vue.component("CustomerName", CustomerName);
                Vue.component("DateTime", DateTime);
                Vue.component("DropZone", DropZone);
                Vue.component("DoughnutChart", DoughnutChart);
                Vue.component("Emails", Emails);
                Vue.component("Error", Error);
                Vue.component("ErrorPlaceholder", ErrorPlaceholder);
                Vue.component("Errors", Errors);
                Vue.component("Field", Field);
                Vue.component("File", File);
                Vue.component("FormatSelect", FormatSelect);
                Vue.component("Filters", Filters);
                Vue.component("Graph", Graph);
                Vue.component("InfiniteAutocomplete", InfiniteAutocomplete);
                Vue.component("Info", Info);
                Vue.component("InfoCard", InfoCard);
                Vue.component("LineChart", LineChart);
                Vue.component("List", List);
                Vue.component("Loading", Loading);
                Vue.component("Lookup", Lookup);
                Vue.component("MasterSvg", MasterSvg);
                Vue.component("MetadataSearch", MetadataSearch);
                Vue.component("Modal", Modal);
                Vue.component("ModalContent", ModalContent);
                Vue.component("SwalDialog", SwalDialog);
                Vue.component("Placeholder", Placeholder);
                Vue.component("Price", Price);
                Vue.component("QuantityInput", QuantityInput);
                Vue.component("ProductName", ProductName);
                Vue.component("SearchBillingAccount", SearchBillingAccount);
                Vue.component("SearchCatalog", SearchCatalog);
                Vue.component("SearchCustomer", SearchCustomer);
                Vue.component("SearchCustomerInvoice", SearchCustomerInvoice);
                Vue.component("SearchEstablishment", SearchEstablishment);
                Vue.component("SearchShipment", SearchShipment);
                Vue.component("SearchReceipt", SearchReceipt);
                Vue.component("SearchObject", SearchObject);
                Vue.component("SearchOrder", SearchOrder);
                Vue.component("SearchOrganization", SearchOrganization);
                Vue.component("SearchProduct", SearchProduct);
                Vue.component("SearchProvider", SearchProvider);
                Vue.component("SearchStock", SearchStock);
                Vue.component("SearchUser", SearchUser);
                Vue.component("ProviderName", ProviderName);
                Vue.component("ReadonlyAccount", ReadonlyAccount);
                Vue.component("RessourceError", RessourceError);
                Vue.component("RessourceNotFound", RessourceNotFound);
                Vue.component("ScopedRouteLink", ScopedRouteLink);
                Vue.component("Select", Select);
                Vue.component("StitchHint", StitchHint);
                Vue.component("SelectFile", SelectFile);
                Vue.component("Stat", Stat);
                Vue.component("Stroke", Strike);
                Vue.component("Table", Table);
                Vue.component("Tabs", Tabs);
                Vue.component("TextField", TextField);
                Vue.component("Title", Title);
                Vue.component("Warning", Warning);
        },
};
